function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PokerState = /*#__PURE__*/function () {
  function PokerState() {
    _classCallCheck(this, PokerState);
  }
  return _createClass(PokerState, [{
    key: "returnState",
    value: function returnState(num_of_players) {
      var state = {};
      state.round = 1;
      state.flipped = 0;
      state.player_cards = {};
      state.player_cards_reported = 0;
      state.player_cards_required = 0;
      state.plays_since_last_raise = 0;
      state.big_blind_player = 1;
      state.small_blind_player = 2;
      state.button_player = 3;
      if (num_of_players == 2) {
        state.button_player = 2;
        state.big_blind_player = 1;
        state.small_blind_player = 2;
      }
      state.player_names = [];
      state.player_pot = [];
      state.player_credit = [];
      state.passed = [];
      state.debt = [];
      state.chip_exchange = [];
      state.winners = [];
      state.last_fold = null;

      //
      // initializeGameStake should flesh this out
      //
      for (var i = 0; i < num_of_players; i++) {
        state.passed[i] = 0;
        state.player_pot[i] = 0;
        state.player_credit[i] = 0;
        state.debt[i] = 0;
        state.player_names[i] = this.app.keychain.returnUsername(this.game.players[i]);
        state.chip_exchange[i] = new Array(num_of_players).fill(0);
      }
      state.big_blind = 2;
      state.small_blind = 1;
      state.last_raise = 2;
      state.required_pot = 2;
      state.all_in = false;
      return state;
    }
  }, {
    key: "returnStats",
    value: function returnStats() {
      var stats = {};
      for (var i = 0; i < this.game.players.length; i++) {
        stats[this.game.players[i]] = {};
        stats[this.game.players[i]].hands = 0;
        stats[this.game.players[i]].wins = 0;
        stats[this.game.players[i]].folds = 0;
        stats[this.game.players[i]].walks = 0;
        stats[this.game.players[i]].vpip = 0;
        stats[this.game.players[i]].showdowns = 0;
      }
      return stats;
    }
  }, {
    key: "removePlayerFromState",
    value: function removePlayerFromState(pkey) {
      var index = this.game.players.indexOf(pkey);
      if (index >= 0 && index < this.game.state.player_names.length) {
        this.game.stats[pkey].final_chips = this.game.state.player_credit[index];
        this.game.state.player_names.splice(index, 1);
        this.game.state.player_pot.splice(index, 1);
        this.game.state.player_credit.splice(index, 1);
        this.game.state.passed.splice(index, 1);
        this.game.state.debt.splice(index, 1);
        for (var i = 0; i < this.game.players.length; i++) {
          if (index !== i) {
            this.game.state.chip_exchange[i].splice(index, 1);
          }
        }
        this.game.state.chip_exchange.splice(index, 1);
        return "".concat(this.game.stats[pkey].final_chips, " CHIPS");
      } else {
        console.warn('Invalid index removePlayerFromState');
      }
    }
  }, {
    key: "addPlayerToState",
    value: function addPlayerToState(pkey) {
      var index = this.game.players.indexOf(pkey);
      console.log(pkey, index, this.game.players);
      this.game.state.player_names.push(this.app.keychain.returnUsername(this.game.players[index]));
      this.game.state.player_pot.push(0);
      this.game.state.player_credit.push(this.game.chips);
      this.game.state.passed.push(0);
      this.game.state.debt.push(0);
      for (var i = 0; i < this.game.players.length; i++) {
        if (index !== i) {
          this.game.state.chip_exchange[i].splice(index, 0, 0);
        } else {
          this.game.state.chip_exchange.splice(index, 0, new Array(this.game.players.length).fill(0));
        }
      }

      // And for stats...

      this.game.stats[pkey] = {};
      this.game.stats[pkey].hands = 0;
      this.game.stats[pkey].wins = 0;
      this.game.stats[pkey].folds = 0;
      this.game.stats[pkey].walks = 0;
      this.game.stats[pkey].vpip = 0;
      this.game.stats[pkey].showdowns = 0;
    }
  }]);
}();
module.exports = PokerState;